import {find, get, sortBy} from 'lodash';
import { CAMERA_VIEWS } from '../../app/configuration/cameras';
import BaseService from '../../middleware/BaseService';

const getCachedChannelsArray = (response, machineType) => {
  const channels = [];
  const CAMERA_CHANNELS = CAMERA_VIEWS.get(machineType);
  const CAMERA_CHANNELS_SORTED = sortBy(CAMERA_CHANNELS, c => c.formOrder);
  CAMERA_CHANNELS_SORTED && Object.keys(CAMERA_CHANNELS_SORTED).map((key) => {
    const camera = CAMERA_CHANNELS_SORTED[key];
    const cameraResponse = find(response, {id: camera.channelIndex});
    channels.push({
      id: cameraResponse?.id,
      name: camera.name || camera.detailskey,
      hasBlackImage: cameraResponse?.hasNoImage,
      image: cameraResponse?.url
    });
  });

  return channels;
};

const getLiveChannelsArray = (response, machineType) => {
  const channels = [];
  const CAMERA_CHANNELS = CAMERA_VIEWS.get(machineType);
  const CAMERA_CHANNELS_SORTED = sortBy(CAMERA_CHANNELS, c => c.formOrder);
  CAMERA_CHANNELS_SORTED && Object.keys(CAMERA_CHANNELS_SORTED).map((key, index) => {
    const camera = CAMERA_CHANNELS_SORTED[key];
    channels.push({
      id: camera.channelIndex,
      name: camera.detailskey,
      image: get(response, `[snap${camera.channelIndex}].data`, null)
    });
  });

  return channels;
}

const buildSnapshots = (response, cached, machineType) => {
  let snapshots = null;

  if (response.error) {
    return snapshots;
  }

  if (cached) {
    const cachedSnapshots = response.snapshots;

    if (!cachedSnapshots) {
      return snapshots;
    }

    const {channels} = cachedSnapshots;

    snapshots = {
      snapshots: {
        lastUpdatedAt: cachedSnapshots.lastUpdated,
        channels: getCachedChannelsArray(channels, machineType)
      }
    };
  } else {
    snapshots = {
      snapshots: {
        channels: getLiveChannelsArray(response, machineType)
      }
    };
  }

  return snapshots;
};

class DVRSnapshotsService extends BaseService {
  async getSnapshots(dvr, options = {}) {
    const cached = get(options, 'cached', false);

    let uri = `/dvr/${dvr.serialNumber}/snaps`;

    if (cached) {
      uri = `${uri}/cache`;
    }

    const response = await this.search({enabled: true}, uri);

    const {machineType} = dvr;
    return buildSnapshots(response, cached, machineType);
  }
}

export default new DVRSnapshotsService();
